<span
    (click)="toggleFavorite()"
    [ngClass]="'article-favorite'"
    [class]="isFavorite ? 'is-favorite' : ''"
>
    <img class="outline" src="/assets/images/icons/heart-outline.svg" alt="" />
    <img class="favorite" src="/assets/images/icons/heart-filled.svg" alt="" />
</span>
